var map = {
	"./en/pre/slogan.png": "JFl1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uPLz";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1 ^\.\/.*\/pre\/slogan\.png$
// module id = uPLz
// module chunks = 0